import { Box, createTheme, styled } from "@mui/material";

export const MRTBox = styled(Box)(() => ({
  display: "flex",
  flex: "1 1 0%",
  flexDirection: "column",
  minHeight: 0,
}));

export const localTheme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          color: "#fff",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: "#fff",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          color: "#fff !important",
        },
      },
    },
  },
});

export const tableStyles = {
  muiTableBodyProps: {
    sx: {
      color: "#fff",
      "& tr:nth-of-type(even) ": {
        bgcolor: "rgba(93, 93, 93, 0.7)",
      },
    },
  },
  muiTableBodyRowProps: {
    sx: {
      bgcolor: "rgba(30, 30, 30, 0.7)",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      fontFamily: " Helvetica",
      fontSize: (theme: any) => theme.typography.pxToRem(14),
      fontWeight: "400",
      color: "#fff",
    },
  },
  muiTablePaperProps: {
    sx: {
      boxShadow: "none",
      bgcolor: "transparent",

      "& .MuiBox-root, & .MuiFormLabel-root, & .MuiSvgIcon-root ": {
        bgcolor: "transparent",
        color: "#fff",
      },
    },
  },
  muiFilterTextFieldProps: {
    sx: {
      m: `4px 0`,
      width: "100%",
      border: "1px solid white",
    },
    variant: "outlined" as const,
  },
  muiCircularProgressProps: {
    color: "secondary" as const,
  },

  muiTableContainerProps: {
    sx: {
      userSelect: "text",
    },
  },
  muiTableHeadRowProps: {
    sx: {
      bgcolor: "transparent",
      color: "#fff",
      "& .MuiButtonBase-root, & .MuiTableSortLabel-icon-root": {
        opacity: "1",
        color: "#fff ",
      },
    },
  },
  muiTableHeadCellProps: {
    sx: {
      color: "#fff ",
      fontSize: (theme: any) => theme.typography.pxToRem(14),
      "& svg ": {
        fill: "#fff ",
      },
    },
  },
};
